import { css } from 'styled-components';
import BREAK_POINTS from './media-queries';
import { BREAKPOINT_MOBILE } from '../components/Header/constants';

export const COLOR_SECTION_LIGHT_BLUE = '#E8F0F5';
export const COLOR_SECTION_LIGHT_GRAY = '#F9F9F9';
export const COLOR_SECTION_LIGHT_GREEN = '#EEF7F6';

export const maxWidthFormTablet = css`
  @media ${BREAK_POINTS.tablet} {
    max-width: 550px;
  }
`;

export const mobileBreakPointWidth = css`
  max-width: 280px;

  @media ${BREAK_POINTS.mobileBig} {
    max-width: 315px;
  }
`;

export const LeftContentContainerStyles = css`
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 5%;
  padding-right: 5%;

  @media ${BREAK_POINTS.tablet} {
    padding-top: inherit;
    padding-bottom: inherit;
    padding-left: 10%;
    padding-right: 5%;
  }
`;

export const ResponsiveSubtitle = css`
  margin-top: 30px;
  font-style: normal;
  font-weight: normal;
  color: #1b1b1b;

  line-height: 28px;
  font-size: 28px;

  @media ${BREAK_POINTS.tabletBig} {
    line-height: 30px;
    font-size: 30px;
  }

  @media ${BREAK_POINTS.tabletBig} {
    line-height: 32px;
    font-size: 32px;
  }

  @media ${BREAK_POINTS.desktop} {
    line-height: 35px;
    font-size: 34px;
  }
`;

export const ResponsiveHeader = css`
  margin-top: 30px;
  line-height: 40px;
  font-size: 40px;

  @media ${BREAK_POINTS.mobileBig} {
    margin-top: 40px;
    line-height: 45px;
    font-size: 45px;
  }

  @media ${BREAK_POINTS.tabletBig} {
    margin-top: 45px;
    line-height: 50px;
    font-size: 50px;
  }

  @media ${BREAK_POINTS.desktop} {
    margin-top: 55px;
    line-height: 55px;
    font-size: 55px;
  }
`;

export type CallToActionProps = { inverted?: boolean; disabled?: boolean };

export const CallToActionHovered = css<CallToActionProps>`
  ${(props) =>
    props.disabled
      ? ''
      : `
      filter: ${props.inverted ? '' : 'brightness(1.1)'};
      ${
        props.theme.styles.buttonShadow &&
        `
        box-shadow: 0px 6px 25px 6px rgba(0, 0, 0, 0.1);
      `
      }
  `}
`;

export const CallToActionDisabled = css`
  border: none;
  color: #fff;
  background-color: lightgrey;
  cursor: not-allowed;
  ${(props) =>
    props.theme.styles.buttonShadow &&
    `
    box-shadow: 0px 5px 12px rgba(0, 0, 0, 0);
  `}
`;

export const CallToActionFocused = css`
  filter: brightness(0.9);
  ${(props) =>
    props.theme.styles.buttonShadow &&
    `
    -webkit-box-shadow: 0px 6px 25px 6px rgba(0, 0, 0, 0.2);
    -moz-box-shadow: 0px 6px 25px 6px rgba(0, 0, 0, 0.2);
    box-shadow: 0px 6px 25px 6px rgba(0, 0, 0, 0.2);
  `}
`;

// Don't be afraid to leave this component better than you found it :)
export const CallToAction = css<{ inverted?: boolean }>`
  display: inline-block;
  position: relative;
  transition: background-color 0.2s, color 0.2s, filter 0.2s, box-shadow 0.2s;
  -webkit-tap-highlight-color: initial;
  border-radius: 2em;
  background-color: ${(props) => (props.inverted ? '#fff' : props.theme.colors.signupNextButtonAccent)};
  padding: ${(props) => (props.inverted ? '14px 28px' : '16px 30px')};
  box-sizing: border-box;
  outline: none;
  border: ${(props) => (props.inverted ? `2px solid ${props.theme.colors.primaryAccentOnWhite}` : 'none')};
  font-size: 16px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  color: ${(props) =>
    props.inverted ? props.theme.colors.primaryAccentOnWhite : props.theme.colors.primaryAccentFontColor};
  box-shadow: ${(props) =>
    props.theme.styles.buttonShadow && !props.inverted ? '0px 5px 12px rgba(0, 0, 0, 0.15)' : 'none'};
  &:hover {
    ${CallToActionHovered}
  }
  &:disabled {
    ${CallToActionDisabled}
  }
  &:focus {
    ${CallToActionFocused}
  }
`;



// WEBPACK FOOTER //
// ./packages/smart-home-support/styling/styles.ts